import { Rule } from '@/optimizer';
import moment from 'moment';

export const convertDailyLimitToYearlyBudget = (
    rules: Rule[],
    startDate: string,
    endDate: string,
): Rule[] => {
    const daysDifference = moment(endDate, 'DD-MM-YYYY').diff(
        moment(startDate, 'DD-MM-YYYY'),
        'days',
    );

    return rules.map((rule) => {
        if (rule.type === 'Daily limit') {
            return {
                ...rule,
                type: 'Total budget',
                subtype: 'minimum',
                value: (parseFloat(rule.value) * daysDifference).toString(),
            };
        }
        return rule;
    });
};
